import { Type } from 'class-transformer';
import { SORespProject } from '../project/so-resp-project';
import { SORespOrganization } from '../organization/so-resp-organization';
import {ObjectiveProtocol} from 'lionheartland';
import {Entity} from "../../dexie/db";

export class SORespEntity implements ObjectiveProtocol {

  entityType: string = 'entity';
  uid: string;
  name: string;
  description: string = "";
  editPermissions: boolean;
  @Type(() => SORespProject)
  project: SORespProject;
  @Type(() => SORespOrganization)
  organization: SORespOrganization;

    toEntity(): Entity {
        return {
            uid: this.uid,
            name: this.name,
            description: this.description,
            dateCreated: null,
            editPermissions: this.editPermissions,
            entityPermissionsUid: null,
            realizationsUid: null,
            simpleAttributesUid: null,
            relationshipAttributesUid: null,
            interphacesUid: null,
            projectUid: this.project ? this.project.uid : null,
            organizationUid: this.organization ? this.organization.uid : null,
}

        };
}